<template>
  <div class="Installation-process">
    <div
      class="activate-home"
      v-for="i in activateImgSrc"
      :key="i.vulae"
    >
      <img
        :src="i.stepImgUrl"
        alt=""
        class="step-img"
        @click="order(i)"
      >
      <img
        class="activate-img"
        :src="i.imgUrl"
        alt
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
  },
  data () {
    return {
      activateImgSrc: [
        {
          imgUrl: require('../assets/images/OBUHomePage/OBUHomePage_01.png'),
          // stepImgUrl: "",
          value: 1
        },
        {
          imgUrl: require('../assets/images/OBUHomePage/OBUHomePage_02.png'),
          // stepImgUrl: "",
          value: 2
        },
        {
          imgUrl: require('../assets/images/OBUHomePage/OBUHomePage_03.png'),
          // stepImgUrl: "",
          value: 3
        },
        {
          imgUrl: require('../assets/images/OBUHomePage/OBUHomePage_04.png'),
          stepImgUrl: require('../assets/images/OBUHomePage/step.png'),
          value: 4
        },
        {
          imgUrl: require('../assets/images/OBUHomePage/OBUHomePage_05.png'),
          stepImgUrl: require('../assets/images/OBUHomePage/step.png'),
          value: 5
        },
        // {
        //   imgUrl: require('../assets/images/OBU激活主页/OBU激活主页_01.png')
        // }
      ]
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    order (val) {
      if (val.value === 4) {
        this.$router.push({
          name: 'HaveOrder'
        })
        return
      }
      if (val.value === 5) {
        this.$router.push({
          name: 'NoOrder'
        })
        return
      }
    }
  },
  components: {
  }
}
</script>
<style scoped lang="scss">
.Installation-process {
  .activate-home {
    position: relative;
    .activate-img {
      width: 100%;
      height: 100%;
    }
    .step-img {
      // opacity: 0;
      width: 70%;
      height: 10%;
      z-index: 999;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .step-img img[src=""],
    img:not([src]) {
      opacity: 0;
    }
  }
  .activate-home:nth-child(4) {
    .step-img {
      bottom: 13%;
    }
  }
  .activate-home:nth-child(5) {
    .step-img {
      bottom: 18%;
    }
  }
}
</style>